import { SearchQueryOrderDirection } from "types/generated";

export const INITIAL_SORT_OPTION = "createdAt";
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
export const FILTER_TYPE = "intent-project-operations";

export enum IntentProjectResourcesSuggestions {
  SPACE = "space",
  INTENT_PROJECT = "intentProject",
  PROVIDER = "provider",
  RESOURCE_ID = "resourceId",
  RESOURCE_TYPE = "resourceType",
  STATE = "state",
  CREATED_AT = "createdAt",
}

export const INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY: Record<string, string> = {
  [IntentProjectResourcesSuggestions.INTENT_PROJECT]: "Intent project",
  [IntentProjectResourcesSuggestions.PROVIDER]: "Provider",
  [IntentProjectResourcesSuggestions.RESOURCE_ID]: "Resource ID",
  [IntentProjectResourcesSuggestions.RESOURCE_TYPE]: "Resource type",
  [IntentProjectResourcesSuggestions.STATE]: "Status",
};
